import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SwitchProjectDialog } from "./dialog/switch-project-dialog";
import { ProjectService } from '../../../shared/service/project.service';

export interface SwitchProjectsData {
  id: string,
  name: string,
  city: {
    name: string
  },
  firstGalleryImage: {
    url: string
  },
  state: {
    name: string
  },
  company: {
    name: string
  },
}

@Component({
  selector: "app-switch-project",
  templateUrl: "./switch-project.component.html"
})
export class SwitchProjectComponent implements OnChanges {
  project: any = [];
  selectedProject: any = {};

  @Input("projects")
  projectsList: SwitchProjectsData[] = [];

  @Input("selected")
  selectedProjectId: string;

  @Input("disableSwitchProject")
  disableSwitchProject: boolean;

  @Output("change")
  projectChangeEmitter: EventEmitter<string> = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    public projectSvc: ProjectService) {

    this.projectSvc.SwitchProjectParams();
    this.projectSvc.Current$.subscribe(() => this.project = this.projectSvc.Projects);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.projectsList) {
      this.selectedProject = this.projectsList.find(x => x.id == this.selectedProjectId);
    }
  }

  switchProject() {
    if (this.disableSwitchProject)
      return;
    if (this.projectSvc?.Projects?.length < 2)
      return;

    const dialogRef = this.dialog.open(SwitchProjectDialog, {
      width: '320px',
      panelClass: 'switch-project-dialog',
      data: {
        projectList: this.projectsList,
        selectedProject: this.selectedProjectId
      }
    });

    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        if (value !== this.selectedProjectId) {
          this.selectedProjectId = value;
          this.selectedProject = this.projectsList.find(x => x.id == this.selectedProjectId);
          this.projectChangeEmitter.emit(value);
        }
      }
    });
  }
}